import { makeOptionallyAuthenticatedQuery } from '@b-stock/fe-core/bstock-next/queries'
import { buildAxiosRequestConfig } from '@b-stock/fe-core/bstock-react'
import type { GetSuggestedSearches200Response } from '@b-stock/search-api-client'

import getAllListingsSearchClient from './getAllListingsSearchClient'

type SuggestedSearchParams = {
  limit?: number
}

const getSuggestedSearchData = async (
  _accessToken: string | null,
  { limit }: SuggestedSearchParams
): Promise<GetSuggestedSearches200Response> => {
  try {
    const searchClient = getAllListingsSearchClient()
    const axiosParams = buildAxiosRequestConfig({ accessToken: _accessToken })

    const response = await searchClient.getSuggestedSearches(
      { limit },
      axiosParams
    )

    return response.data
  } catch (_error) {
    // Fail gracefully - return empty suggestions
    return { suggestedSearches: [], limit: limit || 5 }
  }
}

const suggestedSearchQuery = makeOptionallyAuthenticatedQuery<
  [SuggestedSearchParams],
  GetSuggestedSearches200Response
>('suggestedSearch', getSuggestedSearchData, {
  staleTime: 30 * 60 * 1000, // 30 minutes - suggested searches don't change frequently
})

export default suggestedSearchQuery
